module.exports = __webpack_public_path__ + "static/media/CALIDADen_servicio.98db67bb.jpg";